"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'question.delete.confirm.title': 'Delete Question',
    'question.delete.confirm.message': 'Are you sure you want to delete this question?',
};
